/*
 * @Author: linwl 1015547748@qq.com
 * @Date: 2025-11-12 10:09:05
 * @LastEditors: linwl 1015547748@qq.com
 * @LastEditTime: 2025-11-14 11:03:46
 * @FilePath: \mall\src\api\userCoupon.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request'

export function couponAndLoginApi(data) {
  return request({
    url: '/user-coupon/coupon-and-login',
    method: 'post',
    data: data,
    isNoTVerify: true,
    loading: false
    // headers: {
    //   'Login-Type': 'user-coupon'
    // }
  })
}

export function couponExchangeApi(data) {
  return request({
    url: '/user-coupon/coupon-exchange',
    method: 'post',
    data: data,
    isNoTVerify: true,
    loading: false
  })
}
